import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import ADIColors from "@NA/Utils/ADIColors";
import { showMonthlyFlyer } from "@NA/Utils/Utility";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { FooterContext } from "@insite/content-library/Pages/Footer";
import { StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const billToId = state.context.session.billToId;
    let acNoSession;
    if (billToId) {
        acNoSession = state.data.billTos.byId[billToId]?.customerNumber
    }
    return {
        userRoles: state.ADIGlobalData.ADIUserRoleStore,
        session: state.context.session,
        acNoSession,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;


export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    widgetGridItem?: GridItemProps;
    widgetGridItemInner?: GridItemProps;
    companyGridItem?: GridItemProps;
    websitesGridItem?: GridItemProps;
    resourcesGridItem?: GridItemProps;
    supportGridItem?: GridItemProps;
    connectWithUsGridItem?: GridItemProps;
    downloadsGridItem?: GridItemProps
    bannerGridItem?: GridItemProps
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
                margin: 0px auto;
                padding: 0 15px 84px 15px;
                max-width: 1470px !important;
                 ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`padding: 0 50px 48px 50px;`,
                    null,
                    null,
                ],)}
                .list-title {
                    font-size: 18px !important;
                }
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` padding: 0 27px 12px 27px; `,], "max",);
            }}
                > ${GridOffset}{ 
                    ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` margin: 0px; width: 100%; `,], "max",);
            }}            
                    h3 {
                        color: ${ADIColors.gray6};
                        font-size: 18px !important;
                    }
                    ${StyledButton}{ 
                        &:hover {
                            color: ${ADIColors.gray6};;
                        }
                        span {
                            color: ${ADIColors.gray6};
                            white-space: nowrap;
                            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                                                            font-weight:600;
                                                            font-size:14px;
                                                            margin-top:10px;
                                                            line-height:normal;
                                                        `,
                    css`
                                                            font-weight:600;
                                                            font-size:14px;
                                                            margin-top:10px;
                                                            line-height:normal;
                                                        `,
                    css`
                                                            font-weight:600;
                                                            font-size:14px;
                                                            margin-top:10px;
                                                            line-height:normal;
                                                        `,
                    null,
                    null,
                ])}
                            &:hover {
                                color: ${ADIColors.gray6};
                            }
                        }
                    }
                    .title-wrapper, .links-wrapper {
                        span {
                            color: ${ADIColors.gray6} !important;
                        }
                    }
                 }
            .appStoreContainer{
                margin-bottom: 15px;
                >${StyledButton}{
                    &:focus{
                        outline: none;
                    }
                }
            }
            .googlePlayContainer{
                >${StyledButton}{
                    &:focus{
                        outline: none;
                    }
                }
            }
        `
    },

    widgetGridItemInner: {
        width: [12, 12, 12, 12, 12],
        css: css`
        margin-top: 25px;
        > ${GridOffset}{ 
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` margin: 0px; padding: 0px; width: 100%; `,], "max",);
            }} 
            > ${GridItemStyle} {
                ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` border-top: 1px solid rgb(255 255 255 / 30%); `,], "max",);
            }}
            }
        }
        `
    },
    widgetGridItem: {
        width: [12, 12, 8, 9, 9],
        css: css`
            margin-top: 40px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [null, css` margin-top: 0px !important; order: 2; padding: 0px; `,], "max",);
            }}
        `
    },
    companyGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 15px 10px;`,
                    css`padding: 15px 10px;`,
                    null,
                    null,
                    null,
                ],)}
        `

    },
    websitesGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 15px 10px;`,
                    css`padding: 15px 10px;`,
                    null,
                    null,
                    null,
                ],)}
        `
    },
    resourcesGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 15px 10px;`,
                    css`padding: 15px 10px;`,
                    null,
                    null,
                    null,
                ],)}
        `
    },
    supportGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 15px 10px;`,
                    css`padding: 15px 10px;`,
                    null,
                    null,
                    null,
                ],)}
        `
    },
    connectWithUsGridItem: {
        width: [12, 12, 6, 3, 3],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`padding: 15px 10px;`,
                    css`padding: 15px 10px;`,
                    null,
                    null,
                    null,
                ])}
        `
    },
    downloadsGridItem: {
        width: [6, 6, 5, 2, 2],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`padding-left: 55px;`,
                ],)}
        `
    },
    bannerGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            margin-top: 0px;
            padding: 10px 15px 15px 48px;
            cursor: pointer;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme, [
                    css`padding: 0px 13px 0 2px;display: block;`,
                    css`padding: 0px 13px 0 2px;display: block;`,
                    css`padding: 10px 10px 15px 0px;`,
                    null,
                    null,
                ],);
            }}
        `
    },
};
// bannerGridItem: {
//     width: [12, 12, 4, 3, 3],
//     css: css`
//         margin-top: 0px;
//         padding: 10px 15px 15px 48px;
//         ${({ theme }) => { return breakpointMediaQueries(
//             theme, [null, null, css`padding: 10px 10px 15px 0px;`,],"max",); 
//         }}
//     `
// },
// };
const FooterContainer: FC<Props> = ({ id, extendedStyles, userRoles, session, acNoSession }) => {
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const isProRewardsUser = userRoles && userRoles.adiProRewards;
    const userloyaltyState = useSelector((state: CustomApplicationState) => state.ADIGlobalData?.loyaltyRewardUserStore);
    const accNoLTY = userloyaltyState.user.userId != undefined ? userloyaltyState.user.userId : "";
    const accNoSession = acNoSession?.toString().split('-')[0];
    const userNameSession = useSelector((state: CustomApplicationState) => state.context.session.userName?.toLocaleLowerCase());
    const emailLTY = userloyaltyState.user.email != undefined ? userloyaltyState.user.email?.toLocaleLowerCase() : "";
    const isRewardsInvitedUser = (accNoLTY == accNoSession && userloyaltyState.user.isEnrolled == false && userNameSession == emailLTY &&
        !isProRewardsUser &&
        (userloyaltyState.user.status?.toLocaleUpperCase() == "A" ||
            userloyaltyState.user.status?.toLocaleUpperCase() == "B" ||
            userloyaltyState.user.status?.toLocaleUpperCase() == "O")
    );
    const history = useHistory();
    useEffect(() => {
        const isProductInventoryOnlyRoleValue = isAuthenticated ? (userRoles.productInventoryOnly || (userRoles.productInventoryOnly && userRoles.nationalInventory)) : false;
        if (isProductInventoryOnlyRoleValue) {
            showMonthlyFlyer("links-wrapper");
        }
    }, [isAuthenticated, userRoles])
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    const navigateToAdiProRewards = () => {
        if (isRewardsInvitedUser && isAuthenticated) {
            history.push("/services/adi-pro-rewards/activate");
        } else {
            history.push("/services/adi-pro-rewards");
        }
    }
    return (
        <>
            <GridContainer {...styles.widgetGridContainer}>
                <GridItem {...styles.widgetGridItem}>
                    <GridContainer {...styles.widgetGridItemInner}>
                        <GridItem {...styles.companyGridItem}>
                            <Zone zoneName="companyZone" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.resourcesGridItem}>
                            <Zone zoneName="resourcesZone" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.supportGridItem}>
                            <Zone zoneName="supportZone" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.connectWithUsGridItem}>
                            <Zone zoneName="connectWithUsZone" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem {...styles.bannerGridItem}>
                    <StyledWrapper tabIndex={0} onClick={navigateToAdiProRewards} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); navigateToAdiProRewards(); } }}>
                        <Zone zoneName="ExclusiveBanner" contentId={id} />
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: connect(mapStateToProps)(FooterContainer),
    definition: {
        group: "Footer",
        allowedContexts: [FooterContext],
    },
};

export default footerContainer;
